module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contact container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 flex contact__inner"
  }, [_c('div', {
    staticClass: "contact__inquiries"
  }, [_c('strong', [_vm._v("Inquiries")]), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "contact__email",
    attrs: {
      "href": ("mailto:" + (_vm.contact.email))
    }
  }, [_vm._v(_vm._s(_vm.contact.email))])]), _vm._v(" "), _c('div', {
    staticClass: "contact__address"
  }, [_c('strong', [_vm._v("Thank You For Clapping")]), _c('br'), _vm._v("\n        " + _vm._s(_vm.contact.street)), _c('br'), _vm._v("\n        " + _vm._s(_vm.contact.postal_code) + " " + _vm._s(_vm.contact.city)), _c('br'), _vm._v("\n        " + _vm._s(_vm.contact.country) + "\n      ")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1f1aa9be!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Contact.vue
// module id = 382
// module chunks = 2